import { Modal } from 'react-bootstrap'
interface IModalProps {
    show: boolean
    onHide: () => void
    user: IMoneyPoolResults | undefined
    setIsOpenShareModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsOpenChangeToManagerModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsOpenGuarantorModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsOpenDeactivateModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsChangeNormalModla: React.Dispatch<React.SetStateAction<boolean>>
    setIsActivateModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsOpenChangeToBankerModal?: React.Dispatch<
        React.SetStateAction<boolean>
    >
}
export default function EditUserInformationModal({
    show,
    onHide,
    user,
    setIsOpenShareModal,
    setIsOpenChangeToManagerModal,
    setIsOpenGuarantorModal,
    setIsOpenDeactivateModal,
    setIsChangeNormalModla,
    setIsActivateModal,
    setIsOpenChangeToBankerModal,
}: IModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <>
                {user && user.role === 'nrm' && (
                    <div className=" w-full text-center py-4 text-sm px-4">
                        <p className=" mb-3">
                            ویرایش اطلاعات {user?.member.first_name}{' '}
                            {user?.member.last_name}
                        </p>
                        <hr className=" mb-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenShareModal(true)
                                onHide()
                            }}
                        >
                            {' '}
                            تغییر سهم
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenChangeToManagerModal(true)
                                onHide()
                            }}
                        >
                            ارتقاء به مدیر صندوق
                        </p>
                        {setIsOpenChangeToBankerModal && (
                            <>
                                <hr className=" my-3" />
                                <p
                                    className=" text-green-1"
                                    onClick={() => {
                                        setIsOpenChangeToBankerModal(true)
                                        onHide()
                                    }}
                                >
                                    تبدیل به بانی
                                </p>
                            </>
                        )}
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenGuarantorModal(true)
                                onHide()
                            }}
                        >
                            تغییر ضامن و معرف
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-red-1"
                            onClick={() => {
                                onHide()
                                setIsOpenDeactivateModal(true)
                            }}
                        >
                            غیرفعال سازی
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" my-2"
                            onClick={() => {
                                onHide()
                            }}
                        >
                            بستن
                        </p>
                    </div>
                )}
                {user && user.role === 'mgr' && (
                    <div className=" w-full text-center py-4 text-sm px-4">
                        <p className=" mb-3">
                            ویرایش اطلاعات {user?.member.first_name}{' '}
                            {user?.member.last_name}
                        </p>
                        <hr className=" mb-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenShareModal(true)
                                onHide()
                            }}
                        >
                            {' '}
                            تغییر سهم
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsChangeNormalModla(true)
                                onHide()
                            }}
                        >
                            تغییر به عضو
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenGuarantorModal(true)
                                onHide()
                            }}
                        >
                            تغییر ضامن و معرف
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" my-2"
                            onClick={() => {
                                onHide()
                            }}
                        >
                            بستن
                        </p>
                    </div>
                )}
                {user && user.role === 'bnk' && (
                    <div className=" w-full text-center py-4 text-sm px-4">
                        <p className=" mb-3">
                            ویرایش اطلاعات {user?.member.first_name}{' '}
                            {user?.member.last_name} (بانی)
                        </p>
                        <hr className=" mb-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenShareModal(true)
                                onHide()
                            }}
                        >
                            {' '}
                            تغییر سهم
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsChangeNormalModla(true)
                                onHide()
                            }}
                        >
                            تغییر به عضو
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenChangeToManagerModal(true)
                                onHide()
                            }}
                        >
                            ارتقاء به مدیر صندوق
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenGuarantorModal(true)
                                onHide()
                            }}
                        >
                            تغییر ضامن و معرف
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-red-1"
                            onClick={() => {
                                onHide()
                                setIsOpenDeactivateModal(true)
                            }}
                        >
                            غیرفعال سازی
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" my-2"
                            onClick={() => {
                                onHide()
                            }}
                        >
                            بستن
                        </p>
                    </div>
                )}
                {user && user.role === 'own' && (
                    <div className=" w-full text-center py-4 text-sm px-4">
                        <p className=" mb-3">
                            ویرایش اطلاعات {user?.member.first_name}{' '}
                            {user?.member.last_name}
                        </p>
                        <hr className=" mb-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenShareModal(true)
                                onHide()
                            }}
                        >
                            {' '}
                            تغییر سهم
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsOpenGuarantorModal(true)
                                onHide()
                            }}
                        >
                            تغییر ضامن و معرف
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" my-2"
                            onClick={() => {
                                onHide()
                            }}
                        >
                            بستن
                        </p>
                    </div>
                )}
                {user && user.is_active === false && (
                    <div className=" w-full text-center py-4 text-sm px-4">
                        <p className=" mb-3">
                            ویرایش اطلاعات {user?.member.first_name}{' '}
                            {user?.member.last_name}
                        </p>
                        <hr className=" mb-3" />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsActivateModal(true)
                                onHide()
                            }}
                        >
                            {' '}
                            فعال سازی
                        </p>
                        <hr className=" my-3" />
                        <p
                            className=" my-2"
                            onClick={() => {
                                onHide()
                            }}
                        >
                            بستن
                        </p>
                    </div>
                )}
            </>
        </Modal>
    )
}
